import {
  color,
  inputBaseStyles,
  inputElementStyles,
  optionStyles,
  rem,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const styles = [
  inputBaseStyles,
  optionStyles,
  css`
    :host {
      align-items: normal;
      display: flex;
      flex-direction: column;
      row-gap: ${rem(4)};
    }

    .input-wrapper {
      display: inline-block;
      inline-size: 100%;
      position: relative;
    }

    :where(label) {
      font-weight: bold;
    }

    :where(textarea) {
      ${inputElementStyles};
      align-items: center;
      appearance: none;
      background-color: ${color('white')};
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      flex-shrink: 0;
      inline-size: 100%;
      justify-content: center;
      margin: 0;
      resize: none;
      transition:
        background var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out),
        border var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out),
        color var(--tm-transition-duration-normal)
          var(--tm-transition-function-ease-out);
    }

    :where(textarea):not([disabled]):focus,
    :where(textarea):not([disabled]):focus-visible {
      border-color: ${color('blue', 300)};
    }

    :where(textarea):not([disabled]):hover {
      border-color: ${color('blue')};
    }

    :host([resizable]) :where(textarea) {
      resize: both;
    }

    :where(slot[name='error']) {
      color: ${color('red', 600)};
    }
  `,
];
